import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import {
    getDoubleFeatureFirstImage,
    getDoubleFeatureSecondImage
} from "./components/assets/localized-images";

import { JswDoubleFeatureCard } from "./";

const containerStyles = css({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    [media.below.lg]: {
        padding: "5% 10% 0 10%"
    }
});

const titleStyles = css({
    color: "#000",
    textAlign: "center",
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: "var(--bxp-charlie-display-font-family)",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "48px",
    [media.below.lg]: {
        fontSize: "30px"
    }
});

const cardContainerStyles = css({
    display: "flex",
    justifyContent: "center",
    gap: "30px",
    marginBlockStart: "34px",
    zIndex: "1",
    [media.below.lg]: {
        flexDirection: "column",
        alignItems: "center",
        marginBlockStart: "32px",
        gap: "32px"
    }
});

const blackFooterStyles = css({
    zIndex: "-1",
    marginBlockStart: "-7%",
    width: "100%"
});

export const JswDoubleFeatureSection = () => {
    const intl = useIntl();
    const doubleFeatureItems = [
        {
            title: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.first-card-title-text",
                defaultMessage: "Easily see every team’s progress"
            }),
            description: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.first-card-description-text",
                defaultMessage:
                    "Track every team’s work in a single timeline. Understand progress, map dependencies, and stay ahead of risks."
            }),
            image: getDoubleFeatureFirstImage(intl.locale)
        },
        {
            title: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.second-card-title-text",
                defaultMessage: "Map work to company impact"
            }),
            description: intl.formatMessage({
                id: "jira-product-tour.double-feature-section.second-card-description-text",
                defaultMessage:
                    "With goals in Jira, it’s easy to track all the tasks across projects that contribute to a goal, no matter what team is working on it."
            }),
            image: getDoubleFeatureSecondImage(intl.locale)
        }
    ];

    return (
        <div>
            <div css={containerStyles}>
                <div css={titleStyles}>
                    {intl.formatMessage({
                        id: "jira-product-tour.double-feature-section.title-text",
                        defaultMessage: "Never lose sight of the big picture"
                    })}
                </div>
                <div css={cardContainerStyles}>
                    {doubleFeatureItems.map((item, index) => (
                        <JswDoubleFeatureCard
                            key={index}
                            title={item.title}
                            description={item.description}
                            image={item.image}
                        />
                    ))}
                </div>
            </div>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/dark-shape.webp"
                alt=""
                css={blackFooterStyles}
            />
        </div>
    );
};
JswDoubleFeatureSection.displayName = "JswDoubleFeatureSection";
